import { Modal, TextArea } from "pepsico-ds";
import { useState } from "react";
import "./LogNoteModel.scss";

const LogNoteModel = ({
  showLogNoteModal,
  setShowLogNoteModal,
  onChange,
  onSubmit,
}) => {
  const [note, setNote] = useState("");
  const [changeMade, setChangeMade] = useState("");

  return (
    <Modal
      className="log-note-modal"
      showModal={showLogNoteModal}
      onCloseModal={() => setShowLogNoteModal(false)}
      primaryButtonProps={{
        size: "medium",
        text: "Update",
        variant: "primary",
        disabled: !note?.length && !changeMade?.length,
        onClick: () => onSubmit({ note, changeMade }),
      }}
      secondaryButtonProps={{
        size: "medium",
        text: "Cancel",
        variant: "secondary",
        onClick: () => setShowLogNoteModal(false),
      }}
      showSecondaryButton={true}
      showTertiaryButton={false}
      showLink={false}
      title="Update Note"
    >
      <div className="log-note-content">
        <div className="form-section">
          <TextArea
            label="What's updated"
            placeholder="What's updated"
            value={note}
            showToolbar={false}
            onUpdate={(newNote) => {
              setNote(newNote);
              onChange(newNote, changeMade);
            }}
          />
        </div>

        <div className="form-section">
          <TextArea
            label="Reason for update"
            placeholder="Reason for update"
            value={changeMade}
            showToolbar={false}
            onUpdate={(newChangeMade) => {
              setChangeMade(newChangeMade);
              onChange(note, newChangeMade);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LogNoteModel;
